module.exports = __webpack_public_path__ + "static/img/spgateway.bb1ff65e.png";